import { render, staticRenderFns } from "./majorTransferView.vue?vue&type=template&id=24e37d26&"
import script from "./majorTransferView.vue?vue&type=script&lang=js&"
export * from "./majorTransferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports